import type { Questionnaire } from '@medplum/fhirtypes'

export const PatientEvaluationQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/patient-evaluation',
  status: 'draft',
  subjectType: ['Patient'],
  name: 'Patient Evaluation',
  title: 'Evaluation',
  item: [
    {
      linkId: 'vision',
      text: 'Vision',
      type: 'string',
    },
    {
      linkId: 'hearing',
      text: 'Hearing',
      type: 'string',
    },
    {
      linkId: 'dentition',
      text: 'Dentition',
      type: 'string',
    },
    {
      linkId: 'skin-integrity',
      text: 'Skin integrity',
      type: 'string',
    },
    {
      linkId: 'cognition',
      text: 'Cognition',
      type: 'string',
    },
  ] as const,
} satisfies Questionnaire
